<template>
    <!-- 游戏下拉 -->
    <div class="selector-block" ref="gamelist">
        <div class="select-title" v-if="selectedGame">
            <div class="selected-item">
                <img class="selected-img" :src="selectedGame.logo" :alt="selectedGame.name">
                <div class="selected-name">{{selectedGame.name}}</div>
                <i class="ico-writing ico-selected-delete seleted-delete" @click="deleteGame"></i>
            </div>
        </div>
        <div class="selected-box" v-else>
            <!-- 监听输入，有内容显示下拉框，无内容隐藏下拉框 【【 -->
            <input type="text" class="select-input" placeholder="请选择要发布的内容最相关的游戏（单选）" v-model="searchText" @focus="isShowList = true">
            <!-- 监听输入，有内容显示下拉框，无内容隐藏下拉框 】】 -->
            <!-- 点击显示或隐藏发布游戏内容下拉框 【【 -->
            <i class="ico-writing quick-select-btn" :class="[isShowList ? 'ico-drap-up' : 'ico-drap-down']" @click="isShowList = !isShowList"></i>
            <!-- 点击显示或隐藏发布游戏内容下拉框 】】 -->
            <div class="f-clearfix f-inlineblock-top quick-select-box">
                <div class="quick-select-title f-fl">快速选择</div>
                <div class="quick-select-group f-fr">
                    <div  class="select-img js-sele-hover" @click="choiceGame(item)" v-for="item in recentGame" :key="item.id">
                        <img :src="item.logo" :alt="item.name" width="40" height="40">
                        <div class="select-img-name">
                            <span class="ico"></span>
                            <p class="select-img-name-text">{{item.name}}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="g-selector-option select-group" v-show="isShowList">
                <div class="selector g-scrollbar ">
                    <!-- 下拉框游戏选项，点击添加到 select-title 【【-->
                    <div class="select-item" v-for="item in searchList" :key="item.id" @click="choiceGame(item)">
                        <img class="select-img" :src="item.logo" :alt="item.name">
                        <div class="select-item-title">{{item.name}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
    @import '~Assets/sass/components/dropdown/gamelist_v4.scss';
</style>
<script>
import {
    AllGame, RecentGame
} from 'Services/getData.js';
export default {
    props: {
        isPartList: {
		        type: Boolean,
		        // 对象或数组默认值必须从一个工厂函数获取
		        default: false
        }
    },
    data() {
        return {
            selectedGame: '',
            recentGame: [],
            allGame: [],
            searchText: '',
            isShowList: false,
            selected: 0
        }
    },
    components: {},
    mounted(){
        document.addEventListener('click', (e) => {
            if(this.$refs.gamelist){
                if (!this.$refs.gamelist.contains(e.target)) 
                    this.isShowList = false;
            }
        })
        if(!this.isPartList)
            this.getList();
    },
    computed: {
        searchList() {
            if (this.searchText == '' || this.searchText == undefined) {
                return this.allGame;
            } else {
                let games = [];
                this.allGame.map((item) => {
                    if (item.name.indexOf(this.searchText) != -1){
                        games.push(item);
                    }
                });
                return games;
            }
        }
    },
    methods: {
        async getList(){
            // 所有游戏下拉
            let res1 = await AllGame();
            this.allGame = res1.data.data;

            let res = await RecentGame();
            let resData = [];
            if(res.data.code == 0)
                resData = res.data.data;
            resData.forEach((v, k) => {
                this.allGame.forEach((v2, k2) => {
                    if(v.id == v2.id){
                        this.recentGame.push(v2)
                    }
                })
            })
            // 同步默认选项
            if(this.selected){
                this.syncGameInfoWithId(this.selected);
            }
        },
        partGameList(partGame, partRecentGame){
            // 自定义游戏的下拉
            if(!partGame || !partRecentGame){
                return ;
            }
            this.allGame = partGame;
            partRecentGame.length > 3 ? partRecentGame = partRecentGame.slice(0, 3) : partRecentGame;
            let resData = partRecentGame;
            resData.forEach((v, k) => {
                this.allGame.forEach((v2, k2) => {
                    if(v.id == v2.id){
                        this.recentGame.push(v2)
                    }
                })
            })
            // 同步默认选项
            if(this.selected){
                this.syncGameInfoWithId(this.selected);
            }
        },
        choiceGame(item){
            this.selectedGame = item;
	            this.$emit('gameChange', this.selectedGame);
        },
        deleteGame(){
            this.selectedGame = '';
            this.$emit('gameChange', this.selectedGame);
        },
        syncGameInfoWithId(id){
            this.selected = id;
            this.selectedGame = {};
            try {
                let game = this.allGame.filter((row) => row.id == id);
                if(game.length){
                    this.selectedGame = game[0];
                    this.$emit('gameChange', this.selectedGame);
                }
            }catch (e){
                console.log(e.msg);
            }
        }
    }
}
</script>
